import { OnDestroy, Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs/internal/Subscription';
import { DataService } from '../../_services';
import { DynamicDataTranslationService } from '../../_services/dynamicDataTranslationService';

@Pipe({
  name: 'dynamicDataTranslation',
  pure: false
})
export class DynamicDataTranslation implements PipeTransform, OnDestroy {
  subscriptions = [];
  onLangChange: Subscription;
  currentValue = '';
  constructor(
    private dynamicDataTranslationService: DynamicDataTranslationService,
    private translateService: TranslateService
  ) {
    this.onLangChange = this.translateService.onLangChange.subscribe(() => {
      this.transform(this.currentValue);
    });
  }

  transform(value: any): any {
    this.currentValue = value;
    return this.dynamicDataTranslationService.getTranslatedTextForData(value);
  }

  ngOnDestroy(): void {
    this.onLangChange.unsubscribe();
  }

}
